import React, { useState, useEffect, useRef } from "react"; // add useRef
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import { useHistory, useLocation } from "react-router-dom";
import "./Header.css";
import "../../assets/css/component.css";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { defaultParam, defaultParams } from "./defaultParams";

import cartImg from "../../assets/svgs/m-cart.svg";
import cartImg1 from "../../assets/svgs/my-cart.svg";
import cartImg2 from "../../assets/svgs/red.png";
import logout from "../../assets/svgs/log-out.svg";
import user from "../../assets/svgs/user.svg";
import logo from "../../assets/svgs/logo.svg";
import "../../assets/css/modal.css";
import Step1 from "../Modals/Step1";
import PopUp from "../Modals/Popup";
import Step2 from "../Modals/Step2";
import Step3 from "../Modals/Step3";
import Signup from "../Signup/Signup";
import Signup2 from "../Signup/Signup2";
import VerifiedEmail from "../Modals/VerifiedEmail";

import { loginUser, logoutUser, ClearState } from "../../actions/authActions";

import { mycart, cartLocal } from "../../actions/productActions";
import Spinner from "../../common/Spinner";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import TrackOrder from "../TrackOrder/TrackOrder";
import TrackOrderNow from "../TrackOrderNow/TrackOrderNow";
import MenuModal from "../Menu/MenuModal";

const Header = (props) => {

  /* get parameter values from URL - start */
  const currentPath = useLocation(); // get current url path
  const queryParams = new URLSearchParams(window.location.search);
  let business_id = queryParams.get('business_id');
  let location_id = queryParams.get('location_id');
  if (currentPath.pathname == '/') {

    if (localStorage.getItem("location_id") && localStorage.getItem("business_id")) {
      if (queryParams.get('business_id') !== localStorage.getItem('business_id') || queryParams.get('location_id') !== localStorage.getItem('location_id')) { //CLEAR CART IF DIFFERENT LOCATION/BUSINESS ID
        localStorage.removeItem("cart")
        localStorage.removeItem("deliveryInformation")
        localStorage.removeItem("out_name")
        localStorage.removeItem("paynow_number")
        localStorage.removeItem("amount_rounding_method")
      }
    }
    const verifiedEmail = queryParams.get('verifiedEmail');

    if ((business_id !== null || location_id !== null)) {
      localStorage.removeItem('business_id');
      localStorage.removeItem('location_id');
      localStorage.setItem('business_id', business_id);
      localStorage.setItem('location_id', location_id);
    }


    if (verifiedEmail) {
      localStorage.setItem('verifiedEmail', verifiedEmail);
    }
    else {
      if (localStorage.verifiedEmail) {
        localStorage.removeItem('verifiedEmail');
      }
    }
  }
  /* get parameter values from URL - end */

  const history = useHistory();
  const [show, setShow] = useState(null);
  const [isLoggedIn, setLogin] = useState(false);
  const [signup, setSignup] = useState(null);
  const [signInVal, setSignInVal] = useState(null);
  const [signupVal, setSignupVal] = useState(defaultParams);
  const [popupText, setPopupText] = useState("");
  const [lshow, setLshow] = useState(false);
  const [showVerifiedEmail, setShowVerifiedEmail] = useState(false);
  const [loaded, setLoading] = useState(false);
  const [clLogin, setClogin] = useState(false);
  const [load, setLoad] = useState(false);
  const [name, setUser] = useState(null);
  const [cartData, setCartData] = useState(null);
  const [showtrackOrder, setShowTrackOrder] = useState(false);
  const [showTrackNow, setShowTracknow] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const loginInfo = () => {
    try {
      if (localStorage.login) {
        setLogin(true);
        setLoad(true);
        if (localStorage.headers) {
          var name = localStorage.headers && JSON.parse(localStorage.getItem("headers"));
          var newname = name.data.user.fname + " " + (name.data.user.lname !== null ? name.data.user.lname : '');
          setUser(newname);
        }
        if (localStorage.cart) {
          var data = JSON.parse(localStorage.getItem("cart"));
          props.cartLocal(data);
        }
      } else {
        if (localStorage.cart) {
          var datas = JSON.parse(localStorage.getItem("cart"));
          setLoad(true);
          props.cartLocal(datas);
        }
      }
      if (localStorage.popup && localStorage.login) {
        if (!props.signup_login) {
          setShowMenu(true);
        }
        localStorage.removeItem("popup");
      }

      if (!props.loading && props.add_to_cart !== null && loaded) {
        props.updateCart(props.add_to_cart);
        setCartData(props.add_to_cart);
        if (loaded) {
          console.log("reload");
          localStorage.setItem("popup", true);
          window.location.reload();
        }
      }

      if (localStorage.verifiedEmail) {
        setShowVerifiedEmail(true);
      }
    } catch (error) {
      throw error;
    }
  }

  useEffect(() => {
    console.log("______header_____");
    setCartData(JSON.parse(localStorage.getItem("cart")));
    if (!props.loading && !props.auth.isAuthenticated && clLogin) {
      setClogin(false);
      setLshow(true);
    } else if (props?.signup_login || props.auth.user?.is_otp_verified || (clLogin && !props.loading && props.auth.isAuthenticated)) {
      setLogin(true);
      setClogin(false);
      localStorage.setItem("login", true);
      localStorage.setItem("popup", true);

      setLshow(false);
      setShow(null);

      if (localStorage.cart) {
        var datas = JSON.parse(localStorage.getItem("cart"));
        setLoad(true);
        props.cartLocal(datas);
      }
      setLoading(true);
    }
    if (localStorage.order_id && props.auth.isAuthenticated) {
      console.log("Show track order");
    }

    if (!load) {
      loginInfo();
    }

  }, [clLogin, history, load, loaded, props, props?.auth?.user?.is_otp_verified]);

  useEffect(() => {
    loginInfo();
  }, [props?.auth?.user?.data?.is_register]);

  const cartIcon = document.querySelector(".cart-icon");

  const cartIconRef = useRef(null);

  const flyToCart = (imgRef) => {
    if (!imgRef?.current) return;

    const img = imgRef.current;

    const cartIcon = document.querySelector(
      window.innerWidth < 768 ? ".mycart-mb .cart-icon" : ".right-section .cart-icon"
    );
    if (!cartIcon) return;

    const imgRect = img.getBoundingClientRect();
    const cartRect = cartIcon.getBoundingClientRect();
    const flyingImg = img.cloneNode(true);
    flyingImg.style.position = "fixed";
    flyingImg.style.left = imgRect.left + "px";
    flyingImg.style.top = imgRect.top + "px";
    flyingImg.style.width = imgRect.width + "px";
    flyingImg.style.height = imgRect.height + "px";
    flyingImg.style.transition = "all 0.9s cubic-bezier(0.25, 1, 0.5, 1)";
    flyingImg.style.zIndex = 9999;
    flyingImg.style.pointerEvents = "none";
    flyingImg.style.borderRadius = "8px";

    document.body.appendChild(flyingImg);

    // Animate toward cart
    requestAnimationFrame(() => {
      flyingImg.style.left = cartRect.left + "px";
      flyingImg.style.top = cartRect.top + "px";
      flyingImg.style.width = "35px";
      flyingImg.style.height = "35px";
      flyingImg.style.opacity = 0.4;
      flyingImg.style.transform = "scale(0.5)";
      flyingImg.style.borderRadius = "50%";
    });

    // Clean up
    flyingImg.addEventListener("transitionend", () => {
      flyingImg.remove();
      cartIcon.classList.add("wobble");
      setTimeout(() => cartIcon.classList.remove("wobble"), 600);
    });
  };

  window.flyToCart = flyToCart;


  const showModal = (event, val) => {
    console.log(event, val);

    event && event.preventDefault();
    setShow(val);
  };

  const setLoginValue = (data) => {
    setSignInVal({
      username: data?.username,
      email: data?.email,
      platform: 'Food-Delivery'
    });
  };

  const loginClicked = (data) => {
    // if (data.password && data.phone && !clLogin) {
    if (data.is_otp_verified && data.email && !clLogin) {
      setClogin(true);
    } else if (data.password && data.username && !clLogin) {
      props.loginUser(data, true);
      setClogin(true);
    }
  };

  const CloseloggedIn = () => {
    setShow(null);
  };

  const logoutFunction = () => {
    setLogin(false);

    props.logoutUser();

    if (!localStorage.headers) {
      // localStorage.removeItem("login");
      // localStorage.removeItem("cart");

      props.ClearState();
      props.updateCart(null);
    }
  };

  const showSignup = (event, key) => {
    event.preventDefault();
    setSignup(key);
  };
  const setSignupValue = (data) => {
    setSignupVal(data);
  };

  const SignUPclose = () => {
    setSignup(null);

    {/*if (localStorage.order_id) {
      setShowTrackOrder(true);
    }*/}

    console.log("Sign up close");
  };
  const showTrackOrderNowFunction = () => {
    setShowTrackOrder(false);
    setShowTracknow(true);
  };
  const trackOrderPage = () => {
    setShowTracknow(true);
    if (localStorage.order_id) {
      var order_id = localStorage.order_id;
      localStorage.removeItem("order_id");
      setShowTracknow(false);
      history.push("/track-order/" + order_id);
    }
  };

  return (
    <>
      {/* {props.loading && <Spinner />} */}
      {props.resetPasswordLoading && <Spinner />}
      <header className="page-header">
        <MenuModal show={showMenu} closeModal={() => setShowMenu(false)} />

        <Step1
          show={show === 1 ? true : false}
          closeModal={() => setShow(null)}
          showNext={(event) => showModal(event, 2)}
        />
        <Step2
          show={show === 2 ? true : false}
          setShow={setShow}
          setSignup={setSignup}
          closeModal={() => setShow(null)}
          signInVal={signInVal}
          setLoginValue={setLoginValue}
        // showNext={(event) => showModal(event, 3)}
        />
        <Step3
          signInVal={signInVal}
          loginClicked={loginClicked}
          setLoginValue={setLoginValue}
          show={(show === 3 ? true : false) && !localStorage.headers}
          closeModal={() => {
            CloseloggedIn();
            if (signInVal) { props.ClearState(); }
          }}
          auth={props.auth}              // ✅ Add this
          ClearState={props.ClearState}  // ✅ Add this
        />


        <Signup
          show={signup === 1 ? true : false}
          // closeModal={() => setSignup(null)}
          nextStep={() => setSignup(2)}
          setSignup={setSignupValue}
          signupVal={signupVal}
          closeModal={() => {
            setSignup(null);
            if (signInVal) { props.ClearState(); }
          }}
        />
        <Signup2
          show={signup === 2 ? true : false}
          // closeModal={() => SignUPclose(null)}
          setSignup={setSignupValue}
          previousStep={() => setSignup(1)}
          signupVal={signupVal}
          business_id={business_id}
          location_id={location_id}
          closeModal={() => {
            SignUPclose(null);
            if (signInVal) { props.ClearState(); }
          }}
        />
        <TrackOrder
          show={showtrackOrder}
          closeModal={() => setShowTrackOrder(false)}
          trackOrderNow={() => showTrackOrderNowFunction()}
        />

        <TrackOrderNow
          show={showTrackNow}
          closeModal={() => setShowTracknow(false)}
          trackOrder={() => trackOrderPage()}
        />

        <VerifiedEmail
          show={showVerifiedEmail}
          closeModal={() => setShowVerifiedEmail(false)}
        />

        <div className="is">
          {/* <div className="page-logo">
            <figure>
              <a href="/">
                <img src={logo} alt="" />
              </a>
            </figure>
          </div> */}
          {/* <div className="d-none d-md-block"> */}

          {/* When a long username is given, it wraps under the user icon. 
    Adding a classname and CSS resolves this issue. */}

          <div className="left-section">
            <div className="home-link">
              {
                localStorage.business_id != null && localStorage.location_id != null
                  ? <Link disabled={true} to={'/?business_id=' + localStorage.business_id + '&location_id=' + localStorage.location_id}>
                    {
                      props?.business_details?.[0]?.logo ?
                        <img className="logo_align" src={props?.business_details?.[0]?.logo} alt="Home" />
                        :
                        <h3>{props?.business_details?.[0]?.name}</h3>
                    }
                  </Link>
                  : <Link disabled={true} to={'/'}> Home </Link>
              }
            </div>

            {/*<Button className="pull-right table-Button" variant="danger">
              Table no <span>18</span>
            </Button>*/}
          </div>
          {/* <div className="d-none d-md-block"> */}
          {/* Right Section */}
          <div className="right-section">
            {isLoggedIn && localStorage.business_id != null && localStorage.location_id != null ? (
              <div>
                <Dropdown as={ButtonGroup} className="ml-2 logged-user">
                  <Dropdown.Toggle
                    id="dropdown-custom-1"
                    className="bg-transparent border-0 d-flex align-items-center"
                  >
                    <span className="username">{name && name}</span>
                    <img src={user} className="user-icon ml-2" alt="user" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end" className="main-menu permanent-menu">
                    <Dropdown.Item
                      onClick={() => history.push("/account")}
                      eventKey="1"
                      className="border-bottom"
                    >
                      Account
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="2"
                      className="border-bottom"
                      onClick={() => history.push("/track-order")}
                    >
                      Track Order
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="3"
                      className="border-bottom"
                      onClick={() => history.push("/order-history")}
                    >
                      Order History
                    </Dropdown.Item>
                    <Dropdown.Item as="div" eventKey="4" onClick={logoutFunction} className="signout-item">
                      <Link to={"/"}>Sign out</Link>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            ) : (

              // [(localStorage.business_id!=null && localStorage.location_id!=null ?
              <li className="credential">
                <div href={null} className="cursor">
                  {/* <span
                      ref={props.loginRef}
                      onClick={(event) => showModal(event, 1)}
                    >
                      Log in
                    </span>
                    /
                    <span
                      ref={props.regRef}
                      onClick={(event) => showSignup(event, 1)}
                    >
                      {" "}
                      Sign up
                    </span>
                    <img src={logout} className="ml-2" alt="" /> */}
                  <span
                    ref={props.loginRef}
                    onClick={(event) => showModal(event, 2)}
                    data-testid="user_sign_in"
                  >
                    Log in / Sign up
                    <img src={logout} className="ml-2" alt="" />
                  </span>
                </div>
              </li>

              // : "")]
            )}

            {
              // localStorage.business_id!=null && localStorage.location_id!=null ?
              isLoggedIn ?
                <li className="cart">
                  {/* {props.cartData && props.cartData.count > 0 ? (
                <span className="cart-count-badge">
                  {props.cartData.count && props.cartData.count}
                </span>
              ) : null} */}

                  <div className="d-none d-md-block">
                    {/* {cartData && cartData.count > 0 ? (
                  <span className="cart-count-badge">
                    {cartData.count && cartData.count}
                  </span>
                ) : null} */}
                    {cartData && cartData.length > 0 ? (
                      <span className="cart-count-badge">
                        {cartData.length && cartData.length}
                      </span>
                    ) : ""}
                    <div
                      className="app-data btn btn-outline-ligh"
                      app-data="myCart"
                      onClick={props.showRightBar}
                      data-testid="right_side_bar"
                    >
                      <img
                        ref={cartIconRef}   // 🔹 add this
                        src={cartImg1}
                        alt="cart"
                        className="cart-icon"
                      />

                    </div>
                  </div>
                </li>
                :
                <li className="cart">
                  <div className="d-none d-md-block">
                    {cartData && cartData.length > 0 ? (
                      <span className="cart-count-badge">
                        {cartData.length && cartData.length}
                      </span>
                    ) : ""}
                    <div
                      className="app-data btn btn-outline-ligh"
                      app-data="myCart"
                      onClick={(event) => showModal(event, 2)}
                      data-testid="right_side_bar"
                    >
                      <img
                        ref={cartIconRef}   // 🔹 add this
                        src={cartImg1}
                        alt="cart"
                        className="cart-icon"
                      />

                    </div>
                  </div>
                </li>

            }
          </div>
        </div>

{localStorage.business_id != null &&
 localStorage.location_id != null &&
 !(props.cashregister && props.cashregister.status === "closed") ? 
  <div className="d-block d-sm-none mycart-mb fixed-cart-mobile">
          {/* {props.cartData && props.cartData.count > 0 ? (
              <div
                className="mycartbtn active"
                app-data="myCart"
                onClick={props.showRightBar}
              >
                <span>{props.cartData.count && props.cartData.count}</span>
                <img src={cartImg} alt="cart" className="cart-icon" />
              </div>
            ) : (
              <div
                className="mycartbtn "
                app-data="myCart"
                onClick={props.showRightBar}
              >
                <img src={cartImg} alt="cart" className="cart-icon" />
              </div>
            )} */}

    {cartData && cartData.length > 0 ? (
      <div
        className="mobile-cart-btn-wrapper"
              app-data="myCart"
              // Bug fix: In mobile view, the cart was showing even without login.
              // Now it only appears when the user is logged in.

              //  onClick={props.showRightBar}
              onClick={(event) => {
                if (isLoggedIn) {
                  props.showRightBar();
                } else {
                  showModal(event, 2);
                }
              }}
            >
        <span className="mobile-cart-count">
          {cartData.length && cartData.length}
        </span>
        <img
          ref={cartIconRef}
          src={cartImg2}
          alt="cart"
          className="cart-icon mobile-cart-icon"
        />


      </div>
    ) : (
      <div
        className="mobile-cart-btn-wrapper"
        app-data="myCart"
        onClick={(event) => {
          if (isLoggedIn) {
            props.showRightBar();
          } else {
            showModal(event, 2);
          }
        }}
      >
        <img
          ref={cartIconRef}
          src={cartImg2}
          alt="cart"
          className="mobile-cart-icon"
        />
      </div>
    )}
  </div> : ""}

        <div
          className={`menu-overlay ${props.showMobileHeader ? "open" : ""}`}
        ></div>
        <div className={`ins ${props.showMobileHeader ? "open" : ""}`}>
          <figure className="mb-4">
            <a href="/">
              {" "}
              <img src={logo} alt="logo" />{" "}
            </a>
          </figure>
          {isLoggedIn ? (
            <ul className="menu">
              <li>
                <a href="/" className="user">
                  <figure>
                    <img src="images/user-sm.svg" alt="" />
                  </figure>
                  <span> {name && name}</span>
                </a>
              </li>
              <li className="separator">
                <a href="/" onClick={logoutFunction}>
                  Sign Out
                </a>
              </li>
              <li>
                <a href="/track-order">Track Order</a>
              </li>
              <li>
                <a href="/order-history">Order History</a>
              </li>
            </ul>
          ) : (
            <ul className="menu">
              <li className="separator">
                <a href="/">
                  <span onClick={(event) => showModal(event, 1)}>Login</span>{" "}
                  &nbsp;/ &nbsp;
                  <span onClick={(event) => showSignup(event, 1)}>Sign up</span>
                </a>
              </li>
            </ul>
          )}
          <div className="bottom">
            <a href="/" className="language">
              <img src="images/globe.svg" alt="" /> English
            </a>
            <a href="/" className="close" onClick={props.showMobile}>
              <span aria-hidden="true">×</span>
            </a>
          </div>
        </div>
      </header>
    </>
  );
};

Header.propTypes = {
  showRightBar: PropTypes.func.isRequired,
  showMobile: PropTypes.func.isRequired,
  loginUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  add_to_cart: state.products.add_to_cart,
  loading: state.products.loading,
  resetPasswordLoading: state.user.loading,
  business_details: state?.products?.business_location,
  signup_login: state?.user?.signup,
  cashregister: state.products.cashregister,
});
export default withTranslation()(
  connect(mapStateToProps, {
    ClearState,
    cartLocal,
    logoutUser,
    // mycart,
    loginUser
  })(Header)
);
